import React, { FC, useEffect, useState } from 'react';
import { useCountryContext } from 'context/CountryProvider';
import { getCookiePolicyUrl } from 'common/helpers/documents.helper';

/* Попап по действующей стране (US-034, R-10), от языка страницы не зависит.
 *  Сербский текст попапа без экавских форм — он же черногорский (иекавская норма);
 *  по стране меняется ссылка на политику кукис. */
export const CookiePopup: FC = () => {
  const [show, setShow] = useState(false);
  const { country } = useCountryContext();

  useEffect(() => {
    !document.cookie.includes('AGREE') && setShow(true);
  }, []);

  const onAgreeClick = () => {
    document.cookie = 'AGREE=1';
    setShow(false);
  };

  if (!show) {
    return null;
  }

  return (
    <div className="cookie-popup">
      <div className="cookie-popup__content">
        <span className="cookie-popup__content__text">
          <span>Na ovim stranicama koristimo </span>
          <a href={getCookiePolicyUrl(country)} target="_blank" rel="noopener noreferrer">
            kolačiće (cookies)
          </a>
          <span>
            &nbsp;za bolje iskustvo, funkcionalnost sajta i analizu saobraćaja. Nastavkom korišćenja prihvatate njihovu upotrebu.
          </span>
        </span>
        <button className="btn green-btn" onClick={onAgreeClick}>
          PRIHVATI
        </button>
      </div>
    </div>
  );
};
